<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :value="cursoProgramado.Subcategoria.subcategoria"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
          label="Capacitación"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-select
          label="Capacitadores"
          background-color="primary"
          color="secondary"
          rounded
          filled
          dense
          item-value="id"
          item-text="nombreCompleto"
          v-model="cursoProgramado.fkidCapacitador"
          :items="capacitadores"
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-select
          label="Aula"
          background-color="primary"
          color="secondary"
          rounded
          filled
          dense
          item-value="id"
          item-text="aula"
          v-model="cursoProgramado.fkidAula"
          :items="aulas"
        ></v-select>
      </v-col>
      <v-col v-if="periodoCurso" cols="12">
        <v-date-picker v-model="periodoCurso" locale="es" color="secondary" no-title full-width range></v-date-picker>
      </v-col>
      <v-col cols="6">
        <v-text-field :value="cursoProgramado.fechaInicio" label="Fecha inicio" readonly></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field :value="cursoProgramado.fechaFin" label="Fecha fin" readonly></v-text-field>
      </v-col>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn color="secondary" rounded :loading="loading" :disabled="loading" @click="actualizarCursoProgramado">
          Actualizar capacitacion programada
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      aula: null,
      nombre: null,
      sugcategoria: null,
      periodoCurso: null,
      loading: false,
    }
  },

  mounted() {
    this.periodoCurso = [
      moment(this.cursoProgramado.fechaInicio, this.API_DATE_FORMAT).format(this.VUETIFY_DATE_FORMAT) || null,
      moment(this.cursoProgramado.fechaFin, this.API_DATE_FORMAT).format(this.VUETIFY_DATE_FORMAT) || null,
    ]
  },

  computed: {
    ...mapGetters('cursoProgramado', {
      cursoProgramado: 'getSelectedCursoProgramado',
    }),
    ...mapGetters('aula', {
      aulas: 'getAulas',
    }),
    ...mapGetters('capacitador', {
      capacitadoresList: 'getCapacitadores',
    }),
    capacitadores() {
      return this.capacitadoresList.map((capacitador) => ({
        ...capacitador,
        nombreCompleto: `${capacitador.nombre} ${capacitador.apaterno} ${capacitador.amaterno || ''}`.trim(),
      }))
    },
    ...mapGetters('curso', {
      cursoToUpdate: 'getCursoToUpdate',
    }),
    ...mapGetters('curso', {
      cursos: 'getCursos',
    }),
    getMaxDay: function () {
      return moment().format(this.VUETIFY_DATE_FORMAT)
    },
  },

  watch: {
    periodoCurso(newVal) {
      if (newVal && newVal.length === 2) {
        this.cursoProgramado.fechaInicio = moment(newVal[0], this.VUETIFY_DATE_FORMAT).format(this.API_DATE_FORMAT)
        this.cursoProgramado.fechaFin = moment(newVal[1], this.VUETIFY_DATE_FORMAT).format(this.API_DATE_FORMAT)
      }
    },
  },

  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('dialog', ['CLOSE_DIALOG']),
    ...mapActions('cursoProgramado', ['updateCursoProgramado']),

    async actualizarCursoProgramado() {
      this.loading = true
      try {
        await this.updateCursoProgramado(this.cursoProgramado)
        this.SET_SNACKBAR_MESSAGE('Capacitación programada actualizada correctamente.')
        this.$emit('curso-actualizado')
        this.CLOSE_DIALOG()
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al actualizar la capacitación programada.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
